/**
 * ADR-0024 D10 - geracao do identificador de correlacao do navegador.
 *
 * O valor viaja no header `X-Request-ID`; a API o adota como `request_id` e,
 * por consequencia, como `trace_id` OTEL (ADR-0023 D9). Formato: 32 hex sem
 * hifens, compativel com `trace_id` do W3C Trace Context.
 *
 * ATENCAO ADR-0021: NUNCA usar aqui UUID canonico com hifens - o gate de
 * hygiene procura exatamente esse formato em arquivos versionados.
 */
export function newRequestId(): string {
  const bytes = new Uint8Array(16)
  crypto.getRandomValues(bytes)
  return Array.from(bytes, (b) => b.toString(16).padStart(2, '0')).join('')
}
